// extracted by mini-css-extract-plugin
module.exports = {"makeSearch":"make-module--makeSearch--3_DKh","labelCardSection":"make-module--labelCardSection--1eClr"};